export default __webpack_public_path__ + "static/media/PASIEKA-About-GrzegorzLotysz.1559bb03.jpg";